import { WEEK_ORDER, weekdayNames } from '@goaltree/backend/convex/lib/schedule'
import { cn } from '@goaltree/ui/lib/utils'
import { useTranslation } from 'react-i18next'

// Seven Monday-first day toggles for a "specific days" schedule. Never lets the
// set go empty.
export function RecursDaysChips({
  days,
  onChange,
  className,
}: {
  days: readonly number[]
  onChange: (days: number[]) => void
  className?: string
}) {
  const { t, i18n } = useTranslation()
  const narrow = weekdayNames(i18n.language, 'narrow')
  const short = weekdayNames(i18n.language, 'short')
  return (
    <div
      role="group"
      aria-label={t('inbox.repeatOn')}
      className={cn('flex gap-0.5', className)}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {WEEK_ORDER.map((d) => {
        const on = days.includes(d)
        return (
          <button
            key={d}
            type="button"
            aria-pressed={on}
            aria-label={short[d]}
            onClick={() => {
              const next = on ? days.filter((x) => x !== d) : [...days, d]
              if (next.length) onChange(next.sort((a, b) => a - b))
            }}
            className={cn(
              'flex h-7 w-7 cursor-pointer items-center justify-center rounded text-xs font-medium transition-colors',
              on ? 'bg-primary text-primary-foreground' : 'text-foreground hover:bg-muted',
            )}
          >
            {narrow[d]}
          </button>
        )
      })}
    </div>
  )
}
